
$(function MTH_Generate_Path() {
    let currentUrl = window.location.href;
    $('.pagePath').val(currentUrl);
});